import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { CriteriaInfo } from '../../common/criteriaInfo'
import { selectIsLoadingSomeData } from '../../common/store/slice'
import {
  selectCriteriaIds,
  selectLoading,
  selectSelectedCriteria,
} from '../store/slice'
import { getSavedCriteria } from '../store/thunk'
import { Header } from './Header'
import classes from './index.module.scss'

export const CriteriaPreview = () => {
  const dispatch = useDispatch()

  const firstRowId = useSelector(selectCriteriaIds((data) => data[0]))
  const selectedCriteria = useSelector(selectSelectedCriteria())
  const isLoading = useSelector(selectLoading('selectedCriteria'))
  const isLoadingCommonData = useSelector(selectIsLoadingSomeData)

  useEffect(() => {
    if (!selectedCriteria && firstRowId) {
      dispatch(getSavedCriteria({ Id: firstRowId }))
    }
  }, [selectedCriteria, firstRowId])

  return (
    <Element
      className={classes.criteriaPreview}
      style={{ backgroundColor: '#F3F3F3' }}
    >
      {isLoading || isLoadingCommonData ? (
        <Loading />
      ) : !selectedCriteria ? (
        <Notification />
      ) : (
        <>
          <Header />
          <Element className="flex1">
            <CriteriaInfo
              criteria={selectedCriteria.parameters}
              paddingContent="12px"
            />
          </Element>
        </>
      )}
    </Element>
  )
}
